export default "__VITE_ASSET__6277ee23__"